var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"profile-edit"},[_c('div',{staticClass:"container",staticStyle:{"max-width":"1000px","margin":"auto"}},[_c('edit',{attrs:{"fs":_vm.fs,"id":_vm.user._id,"api":"users","title":"profile"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }